var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRatingNps = function SvgRatingNps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 205,
    viewBox: "0 0 332 205",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2005",
    "data-name": "Ret\\xE2ngulo 2005",
    width: 283.318,
    height: 166.877,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1997",
    "data-name": "Ret\\xE2ngulo 1997",
    width: 283.319,
    height: 166.877,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1996",
    "data-name": "Ret\\xE2ngulo 1996",
    width: 9.903,
    height: 10.126,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4594",
    "data-name": "Caminho 4594",
    d: "M901.319,1113.228a11.374,11.374,0,0,0,2.009,1.557.637.637,0,0,1,.3.467,12.762,12.762,0,0,0,.5,2.357.634.634,0,0,0,.906.365,12.135,12.135,0,0,0,2.068-1.417.634.634,0,0,1,.53-.14,14.143,14.143,0,0,0,1.723.221c.26.017.492.026.689.028a.636.636,0,0,0,.632-.754l-.02-.1a11.739,11.739,0,0,0-.691-2.258A.636.636,0,0,1,910,1113a13.193,13.193,0,0,0,1-2.256.634.634,0,0,0-.512-.827,12.2,12.2,0,0,0-2.586-.093.632.632,0,0,1-.508-.2,14.37,14.37,0,0,0-1.724-1.569.634.634,0,0,0-.963.241,12.971,12.971,0,0,0-.786,2.241.635.635,0,0,1-.347.422,12.359,12.359,0,0,0-2.191,1.307.635.635,0,0,0-.061.961",
    transform: "translate(-901.128 -1107.926)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8.491,
    y1: 5.952,
    x2: -8.481,
    y2: 5.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7598ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95b0ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4618",
    "data-name": "Caminho 4618",
    d: "M248.356,432.288a30.828,30.828,0,1,0,8.007-1.059,30.861,30.861,0,0,0-8.007,1.059",
    transform: "translate(-225.475 -431.229)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1999",
    "data-name": "Ret\\xE2ngulo 1999",
    width: 9.86,
    height: 10.128,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4620",
    "data-name": "Caminho 4620",
    d: "M2535.233,1261.1a11.392,11.392,0,0,0,.961,2.354.637.637,0,0,1,.026.554,12.747,12.747,0,0,0-.743,2.293.634.634,0,0,0,.6.769,12.135,12.135,0,0,0,2.5-.193.634.634,0,0,1,.529.144,14.138,14.138,0,0,0,1.382,1.053c.217.145.413.268.583.368a.635.635,0,0,0,.925-.337l.033-.1a11.729,11.729,0,0,0,.53-2.3.636.636,0,0,1,.3-.464,13.2,13.2,0,0,0,1.991-1.456.634.634,0,0,0-.03-.973,12.209,12.209,0,0,0-2.193-1.373.631.631,0,0,1-.34-.427,14.348,14.348,0,0,0-.709-2.221.634.634,0,0,0-.954-.273,12.956,12.956,0,0,0-1.8,1.547.634.634,0,0,1-.512.192,12.362,12.362,0,0,0-2.551.037.635.635,0,0,0-.534.8",
    transform: "translate(-2535.208 -1258.404)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -24.042,
    y1: 4.567,
    x2: -24.032,
    y2: 4.567,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2001",
    "data-name": "Ret\\xE2ngulo 2001",
    width: 9.859,
    height: 10.128,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4621",
    "data-name": "Caminho 4621",
    d: "M2396.1,1223.819a11.363,11.363,0,0,0,.961,2.354.636.636,0,0,1,.026.554,12.732,12.732,0,0,0-.743,2.293.634.634,0,0,0,.6.77,12.119,12.119,0,0,0,2.5-.194.634.634,0,0,1,.529.144,14.142,14.142,0,0,0,1.382,1.053c.217.145.413.268.583.369a.636.636,0,0,0,.925-.337l.033-.1a11.748,11.748,0,0,0,.53-2.3.636.636,0,0,1,.3-.464,13.17,13.17,0,0,0,1.991-1.456.634.634,0,0,0-.03-.973,12.2,12.2,0,0,0-2.193-1.374.63.63,0,0,1-.34-.427,14.406,14.406,0,0,0-.709-2.221.634.634,0,0,0-.954-.273,12.96,12.96,0,0,0-1.8,1.547.635.635,0,0,1-.512.192,12.35,12.35,0,0,0-2.551.037.635.635,0,0,0-.534.8",
    transform: "translate(-2396.075 -1221.123)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -22.722,
    y1: 4.91,
    x2: -22.712,
    y2: 4.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4643",
    "data-name": "Caminho 4643",
    d: "M2110.7,455.453a30.827,30.827,0,1,0,29.79-22.881,30.861,30.861,0,0,0-29.79,22.881",
    transform: "translate(-2109.637 -432.572)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4674",
    "data-name": "Caminho 4674",
    d: "M1126.582,150.89a34.527,34.527,0,1,0,34.527-34.527,34.527,34.527,0,0,0-34.527,34.527",
    transform: "translate(-1126.582 -116.363)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5775",
    "data-name": "Grupo 5775",
    transform: "translate(-517 -166)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1973",
    "data-name": "Ret\\xE2ngulo 1973",
    width: 332,
    height: 205,
    transform: "translate(517 166)",
    fill: "#fd9649",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5726",
    "data-name": "Grupo 5726",
    transform: "translate(542 187.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5702",
    "data-name": "Grupo 5702",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5701",
    "data-name": "Grupo 5701",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4593",
    "data-name": "Caminho 4593",
    d: "M109.229,370.453,40.755,388.8a9.979,9.979,0,0,1-12.222-7.056L.343,276.535A9.979,9.979,0,0,1,7.4,264.313l68.473-18.347a9.979,9.979,0,0,1,12.222,7.057l28.191,105.209a9.979,9.979,0,0,1-7.056,12.222",
    transform: "translate(0 -222.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5700",
    "data-name": "Grupo 5700",
    transform: "translate(85.693 105.358)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5699",
    "data-name": "Grupo 5699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5698",
    "data-name": "Grupo 5698",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5697",
    "data-name": "Grupo 5697",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5696",
    "data-name": "Grupo 5696",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1995",
    "data-name": "Ret\\xE2ngulo 1995",
    width: 10.082,
    height: 10.356,
    transform: "translate(-0.087 -0.117)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4595",
    "data-name": "Caminho 4595",
    d: "M762.186,1150.509a11.378,11.378,0,0,0,2.009,1.557.637.637,0,0,1,.3.467,12.746,12.746,0,0,0,.5,2.357.634.634,0,0,0,.906.365,12.136,12.136,0,0,0,2.069-1.418.635.635,0,0,1,.53-.14,14.093,14.093,0,0,0,1.723.221c.26.017.492.026.689.028a.635.635,0,0,0,.632-.754l-.02-.1a11.74,11.74,0,0,0-.691-2.258.635.635,0,0,1,.032-.554,13.2,13.2,0,0,0,1-2.256.634.634,0,0,0-.512-.827,12.221,12.221,0,0,0-2.586-.093.63.63,0,0,1-.508-.2,14.343,14.343,0,0,0-1.724-1.569.634.634,0,0,0-.963.241,12.947,12.947,0,0,0-.786,2.241.635.635,0,0,1-.348.422,12.364,12.364,0,0,0-2.191,1.307.635.635,0,0,0-.061.961",
    transform: "translate(-689.533 -1036.303)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4596",
    "data-name": "Caminho 4596",
    d: "M623.052,1187.79a11.378,11.378,0,0,0,2.009,1.557.638.638,0,0,1,.3.467,12.755,12.755,0,0,0,.5,2.357.634.634,0,0,0,.906.365,12.15,12.15,0,0,0,2.068-1.418.635.635,0,0,1,.53-.14,14.14,14.14,0,0,0,1.723.221c.26.017.492.026.689.028a.635.635,0,0,0,.632-.754l-.02-.1a11.742,11.742,0,0,0-.691-2.258.635.635,0,0,1,.032-.554,13.2,13.2,0,0,0,1-2.256.634.634,0,0,0-.512-.827,12.213,12.213,0,0,0-2.586-.093.631.631,0,0,1-.508-.2,14.369,14.369,0,0,0-1.724-1.569.634.634,0,0,0-.963.241,12.952,12.952,0,0,0-.786,2.241.635.635,0,0,1-.348.422,12.372,12.372,0,0,0-2.191,1.307.635.635,0,0,0-.061.961",
    transform: "translate(-563.63 -1070.039)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4597",
    "data-name": "Caminho 4597",
    d: "M483.919,1225.071a11.383,11.383,0,0,0,2.009,1.557.637.637,0,0,1,.3.467,12.748,12.748,0,0,0,.5,2.357.634.634,0,0,0,.906.365,12.132,12.132,0,0,0,2.069-1.417.635.635,0,0,1,.53-.14,14.064,14.064,0,0,0,1.723.221c.26.017.492.026.689.028a.636.636,0,0,0,.633-.754l-.02-.1a11.737,11.737,0,0,0-.691-2.258.636.636,0,0,1,.032-.554,13.185,13.185,0,0,0,1-2.256.634.634,0,0,0-.512-.827,12.213,12.213,0,0,0-2.586-.093.631.631,0,0,1-.508-.2,14.346,14.346,0,0,0-1.724-1.569.634.634,0,0,0-.963.241,12.955,12.955,0,0,0-.786,2.241.634.634,0,0,1-.348.422,12.371,12.371,0,0,0-2.191,1.307.635.635,0,0,0-.061.961",
    transform: "translate(-437.728 -1103.775)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4598",
    "data-name": "Caminho 4598",
    d: "M344.785,1262.351a11.382,11.382,0,0,0,2.009,1.557.637.637,0,0,1,.3.467,12.755,12.755,0,0,0,.5,2.357.634.634,0,0,0,.906.365,12.139,12.139,0,0,0,2.069-1.418.635.635,0,0,1,.53-.14,14.141,14.141,0,0,0,1.723.221c.26.017.492.026.689.028a.635.635,0,0,0,.632-.754l-.02-.1a11.736,11.736,0,0,0-.691-2.258.636.636,0,0,1,.032-.554,13.189,13.189,0,0,0,1-2.256.634.634,0,0,0-.512-.827,12.213,12.213,0,0,0-2.586-.093.631.631,0,0,1-.508-.2,14.362,14.362,0,0,0-1.724-1.569.634.634,0,0,0-.963.241,12.956,12.956,0,0,0-.786,2.241.635.635,0,0,1-.348.422,12.363,12.363,0,0,0-2.191,1.307.635.635,0,0,0-.061.961",
    transform: "translate(-311.825 -1137.51)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4599",
    "data-name": "Caminho 4599",
    d: "M500.976,1321.822,450.4,1335.375a.644.644,0,0,1-.789-.455l0-.013a.644.644,0,0,1,.456-.789l50.581-13.553a.644.644,0,0,1,.789.456l0,.013a.644.644,0,0,1-.456.789",
    transform: "translate(-406.828 -1194.966)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4600",
    "data-name": "Caminho 4600",
    d: "M515.146,1374.7l-50.581,13.553a.644.644,0,0,1-.789-.456l0-.012a.644.644,0,0,1,.456-.789l50.581-13.553a.644.644,0,0,1,.789.456l0,.012a.645.645,0,0,1-.456.789",
    transform: "translate(-419.65 -1242.819)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4601",
    "data-name": "Caminho 4601",
    d: "M632.81,1461.831l-26.275,7.04a.645.645,0,0,1-.789-.456l0-.012a.644.644,0,0,1,.456-.789l26.274-7.04a.644.644,0,0,1,.789.455l0,.013a.644.644,0,0,1-.456.789",
    transform: "translate(-548.12 -1321.661)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4602",
    "data-name": "Caminho 4602",
    d: "M286.153,454.111a30.861,30.861,0,1,1-37.8-21.822,30.861,30.861,0,0,1,37.8,21.822",
    transform: "translate(-204.033 -390.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4603",
    "data-name": "Caminho 4603",
    d: "M252.916,489.965a31.405,31.405,0,0,1-18.832-6.341,31.228,31.228,0,0,1,18.871-56.1,31.405,31.405,0,0,1,18.832,6.341,31.228,31.228,0,0,1-18.871,56.1",
    transform: "translate(-200.625 -386.868)",
    fill: "#dfe9f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5704",
    "data-name": "Grupo 5704",
    transform: "translate(21.442 41.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5703",
    "data-name": "Grupo 5703",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4604",
    "data-name": "Caminho 4604",
    d: "M464.114,936.238a3.627,3.627,0,0,0,2.392-1.9c2.843-4.632,1.786-10.555,2.345-15.959.23-2.221.606-4.44.886-6.7.113-.895.209-1.8.276-2.7.005-.062.01-.123.013-.185,0-.023,0-.045,0-.068a30.748,30.748,0,0,0,.043-3.6,19.135,19.135,0,0,0-1.87-7.682c-.92-1.837-2.5-3.66-4.429-3.71a3.9,3.9,0,0,0-3.322,2.139,11.719,11.719,0,0,0-1.189,4.1c-1.513,9.892-1.1,19.691-.43,28.973a14.957,14.957,0,0,0,.287,2.295,7.794,7.794,0,0,0,2.129,3.776,3.61,3.61,0,0,0,2.865,1.222",
    transform: "translate(-436.096 -849.75)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4605",
    "data-name": "Caminho 4605",
    d: "M472.582,858.814a41.618,41.618,0,0,0,3.072,5.288,94.633,94.633,0,0,1,8.68,18.356l23.216-5.266-4.1-12.878s6.245-8.2-2.093-15.878l-6.8-6.53a6.412,6.412,0,0,0-4.174-1.782,6.152,6.152,0,0,0-.734.01,6.418,6.418,0,0,0-1.479.285l-14.318,4.548s-.032.014-.088.044c-.759.4-6.049,3.622-1.184,13.8",
    transform: "translate(-447.242 -801.234)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4606",
    "data-name": "Caminho 4606",
    d: "M503.52,1037.457l1.971,2.533a94.628,94.628,0,0,1,8.68,18.356l6.423-2.04h0c-.5-.586-1.13-1.044-1.667-1.594a6.857,6.857,0,0,1-1.544-6.86c.366-1.067.971-2.338.253-3.208a2.872,2.872,0,0,0-1.467-.754q-.161-.049-.322-.1a17.107,17.107,0,0,1-10.1-8.893l-.2-.408a30.743,30.743,0,0,1-2.031,2.969",
    transform: "translate(-477.079 -977.121)",
    fill: "#7598ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4607",
    "data-name": "Caminho 4607",
    d: "M529.06,536.385a9.453,9.453,0,0,1-1.189,7.976c-1.673,2.62-5.056,4.913-8,4.125-4.192-1.124-5.6-5.284-5.872-9.129-.162-2.283-.674-9.407,3.078-10.667a4.807,4.807,0,0,1,1.745-.191,11.393,11.393,0,0,1,10.236,7.886",
    transform: "translate(-486.459 -519.242)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4608",
    "data-name": "Caminho 4608",
    d: "M382.628,549.5a13.694,13.694,0,0,0,11.472,8.188,19.291,19.291,0,0,0,4.213-.118c2.93-.375,5.821-1.29,7.7-2.929a8.685,8.685,0,0,0,2.76-5.476,20.752,20.752,0,0,0-2.243-11.982,16.728,16.728,0,0,0-4.123-5.688,7.03,7.03,0,0,0-4.17-1.85,9.41,9.41,0,0,0-4.622,1.326,40.9,40.9,0,0,0-5.269,3c-5.563,3.935-7.831,10.092-5.719,15.526",
    transform: "translate(-366.978 -520.279)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4609",
    "data-name": "Caminho 4609",
    d: "M344.014,581.529a5.143,5.143,0,0,0-5.612.781,6.808,6.808,0,0,0-2.144,5.092c0,2,.806,4.38,2.967,4.849a5.47,5.47,0,0,0,4.927-2.027,7.247,7.247,0,0,0,1.488-6.764,3.526,3.526,0,0,0-1.626-1.931",
    transform: "translate(-325.723 -566.771)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4610",
    "data-name": "Caminho 4610",
    d: "M532.391,755.147c.268.854.912,2.889,1.18,3.744a9.938,9.938,0,0,1,.663,3.729,3.381,3.381,0,0,1-2.014,2.987,4.008,4.008,0,0,1-4.466-1.517,8.359,8.359,0,0,1-.917-2.326,48.146,48.146,0,0,0-2.607-6.786,3.446,3.446,0,0,1-.45-1.241c-.092-1.109.955-2,2.016-2.34a5.228,5.228,0,0,1,4.219.5,5.421,5.421,0,0,1,2.376,3.247",
    transform: "translate(-495.407 -720.739)",
    fill: "#aa7485"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4611",
    "data-name": "Caminho 4611",
    d: "M544.235,832.38a3.391,3.391,0,0,1-.378-.976l-.389-1.425c-.169-.62-.3-1.382.166-1.822a1.773,1.773,0,0,1,.672-.34q3.619-1.214,7.329-2.129a1.517,1.517,0,0,1,.515-.065,1.033,1.033,0,0,1,.726.5,3.059,3.059,0,0,1,.331.844l.465,1.649a6.155,6.155,0,0,1,.227,3.883,3.885,3.885,0,0,1-2.68,2.184,7.847,7.847,0,0,1-3.556-.054,5.517,5.517,0,0,1-.872-.24,6.657,6.657,0,0,1-1.944-1.355,3.392,3.392,0,0,1-.611-.651",
    transform: "translate(-513.087 -788.115)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4612",
    "data-name": "Caminho 4612",
    d: "M455.264,728.372a2.557,2.557,0,0,0-.375,3.2c1.4,2.634,3.985,2.745,5.844,2.638,2.569-.149,2.341-2.718.677-4.61-1.3-1.477-4.44-2.859-6.146-1.225",
    transform: "translate(-432.723 -699.447)",
    fill: "#b7808f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4613",
    "data-name": "Caminho 4613",
    d: "M471.854,562.191a19.126,19.126,0,0,0,3.156,7.631,11.822,11.822,0,0,0,6.7,4.632,9.986,9.986,0,0,0,8.677-2.19,5.621,5.621,0,0,0,1.545-2.014,6.211,6.211,0,0,0-.589-5.2,16.044,16.044,0,0,0-.874-1.523c-.586-.911-1.134-1.844-1.665-2.788-.975-1.728-1.891-3.492-2.869-5.218-1.029-1.818-2.172-3.745-4.062-4.637-2.573-1.214-5.764-.031-7.72,2.035a9.479,9.479,0,0,0-2.608,5.794,13.207,13.207,0,0,0,.3,3.477",
    transform: "translate(-448.13 -539.064)",
    fill: "#b7808f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4614",
    "data-name": "Caminho 4614",
    d: "M482.159,755.937a2.929,2.929,0,0,1-1.705-.546.154.154,0,1,1,.181-.249,2.611,2.611,0,0,0,2,.443.154.154,0,1,1,.059.3,2.793,2.793,0,0,1-.533.051",
    transform: "translate(-456.149 -724.312)",
    fill: "#46506b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4615",
    "data-name": "Caminho 4615",
    d: "M536.878,538.712a6.787,6.787,0,0,1-1.326-4.45,7.933,7.933,0,0,1,1.428-4.638,1.623,1.623,0,0,1,2.85-.07,7.46,7.46,0,0,1,1.094,5.039,8.525,8.525,0,0,1-1.058,3.658,1.88,1.88,0,0,1-2.957.494l-.033-.034",
    transform: "translate(-506.065 -519.467)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4616",
    "data-name": "Caminho 4616",
    d: "M566.7,534.919c-.745.141-1.975-.588-2.9-1.249a13.021,13.021,0,0,1-2.995-3.083c-.7-1.006-.782-1.866-.018-1.839a6.4,6.4,0,0,1,3.278,1.673,13.953,13.953,0,0,1,2.362,2.388c.636.856.932,1.967.293,2.105l-.023,0",
    transform: "translate(-528.411 -519.475)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4617",
    "data-name": "Caminho 4617",
    d: "M456.31,552.218a2.015,2.015,0,0,1-.852-.557,2.7,2.7,0,0,1-.672-1.6,11.072,11.072,0,0,1,.369-3.5,15.309,15.309,0,0,1,6.55-8.772,4.159,4.159,0,0,1,2.371-.936c1.429.088,1.4,1.622,1.184,2.643a23.318,23.318,0,0,1-4.023,9.582c-.841,1.077-3.085,3.733-4.926,3.146",
    transform: "translate(-432.953 -526.8)",
    fill: "#5d5576"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5716",
    "data-name": "Grupo 5716",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5715",
    "data-name": "Grupo 5715",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4619",
    "data-name": "Caminho 4619",
    d: "M1828.761,388.8l-68.473-18.347a9.979,9.979,0,0,1-7.057-12.222l28.191-105.209a9.979,9.979,0,0,1,12.222-7.056l68.474,18.347a9.98,9.98,0,0,1,7.057,12.222l-28.191,105.209a9.979,9.979,0,0,1-12.222,7.057",
    transform: "translate(-1586.198 -222.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5709",
    "data-name": "Grupo 5709",
    transform: "translate(241.086 119.668)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5708",
    "data-name": "Grupo 5708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5707",
    "data-name": "Grupo 5707",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5706",
    "data-name": "Grupo 5706",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5705",
    "data-name": "Grupo 5705",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1998",
    "data-name": "Ret\\xE2ngulo 1998",
    width: 10.024,
    height: 10.362,
    transform: "translate(-0.082 -0.119)",
    fill: "url(#linear-gradient-2)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5714",
    "data-name": "Grupo 5714",
    transform: "translate(227.855 116.122)",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5713",
    "data-name": "Grupo 5713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5712",
    "data-name": "Grupo 5712",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5711",
    "data-name": "Grupo 5711",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5710",
    "data-name": "Grupo 5710",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2000",
    "data-name": "Ret\\xE2ngulo 2000",
    width: 10.025,
    height: 10.362,
    transform: "translate(-0.082 -0.119)",
    fill: "url(#linear-gradient-3)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4622",
    "data-name": "Caminho 4622",
    d: "M2256.966,1186.538a11.379,11.379,0,0,0,.961,2.354.635.635,0,0,1,.026.554,12.77,12.77,0,0,0-.743,2.293.634.634,0,0,0,.6.769,12.127,12.127,0,0,0,2.5-.193.635.635,0,0,1,.529.144,14.09,14.09,0,0,0,1.382,1.053c.217.145.413.268.583.368a.636.636,0,0,0,.925-.337l.032-.1a11.728,11.728,0,0,0,.53-2.3.637.637,0,0,1,.3-.464,13.182,13.182,0,0,0,1.991-1.456.634.634,0,0,0-.03-.972,12.2,12.2,0,0,0-2.193-1.374.632.632,0,0,1-.34-.427,14.375,14.375,0,0,0-.709-2.221.634.634,0,0,0-.954-.273,12.963,12.963,0,0,0-1.8,1.547.634.634,0,0,1-.512.192,12.365,12.365,0,0,0-2.55.037.635.635,0,0,0-.534.8",
    transform: "translate(-2042.318 -1071.265)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4623",
    "data-name": "Caminho 4623",
    d: "M2117.832,1149.258a11.388,11.388,0,0,0,.961,2.353.636.636,0,0,1,.026.554,12.793,12.793,0,0,0-.743,2.293.634.634,0,0,0,.6.769,12.124,12.124,0,0,0,2.5-.194.635.635,0,0,1,.529.144,14.138,14.138,0,0,0,1.382,1.053c.217.145.413.268.583.369a.635.635,0,0,0,.925-.337l.033-.1a11.745,11.745,0,0,0,.531-2.3.635.635,0,0,1,.3-.464,13.208,13.208,0,0,0,1.991-1.456.634.634,0,0,0-.03-.973,12.2,12.2,0,0,0-2.193-1.373.631.631,0,0,1-.34-.427,14.354,14.354,0,0,0-.708-2.221.634.634,0,0,0-.954-.273,12.955,12.955,0,0,0-1.8,1.547.635.635,0,0,1-.512.192,12.359,12.359,0,0,0-2.551.037.635.635,0,0,0-.534.8",
    transform: "translate(-1916.415 -1037.53)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4624",
    "data-name": "Caminho 4624",
    d: "M1978.7,1111.977a11.375,11.375,0,0,0,.961,2.353.636.636,0,0,1,.025.554,12.773,12.773,0,0,0-.743,2.293.634.634,0,0,0,.6.769,12.134,12.134,0,0,0,2.5-.193.635.635,0,0,1,.529.144,14.087,14.087,0,0,0,1.382,1.053c.217.145.413.268.583.369a.636.636,0,0,0,.925-.337l.033-.1a11.727,11.727,0,0,0,.53-2.3.636.636,0,0,1,.3-.464,13.191,13.191,0,0,0,1.991-1.456.634.634,0,0,0-.03-.973,12.211,12.211,0,0,0-2.193-1.374.632.632,0,0,1-.34-.427,14.353,14.353,0,0,0-.709-2.221.634.634,0,0,0-.954-.273,12.947,12.947,0,0,0-1.8,1.547.635.635,0,0,1-.512.192,12.359,12.359,0,0,0-2.551.037.635.635,0,0,0-.534.8",
    transform: "translate(-1790.513 -1003.794)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4625",
    "data-name": "Caminho 4625",
    d: "M2039.705,1336.552,1989.124,1323a.644.644,0,0,1-.456-.789l0-.013a.644.644,0,0,1,.789-.456l50.581,13.553a.644.644,0,0,1,.455.789l0,.013a.644.644,0,0,1-.789.455",
    transform: "translate(-1799.536 -1196.031)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4626",
    "data-name": "Caminho 4626",
    d: "M2025.535,1389.435l-50.581-13.553a.644.644,0,0,1-.456-.789l0-.013a.644.644,0,0,1,.789-.456l50.581,13.553a.644.644,0,0,1,.456.789l0,.013a.644.644,0,0,1-.789.456",
    transform: "translate(-1786.714 -1243.885)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4627",
    "data-name": "Caminho 4627",
    d: "M2114.86,1470.049l-26.274-7.04a.644.644,0,0,1-.456-.789l0-.013a.645.645,0,0,1,.789-.455l26.274,7.04a.644.644,0,0,1,.456.789l0,.013a.644.644,0,0,1-.789.456",
    transform: "translate(-1889.539 -1322.726)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4628",
    "data-name": "Caminho 4628",
    d: "M2170.316,471.428a30.861,30.861,0,1,1-21.822-37.8,30.861,30.861,0,0,1,21.822,37.8",
    transform: "translate(-1909.021 -391.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4629",
    "data-name": "Caminho 4629",
    d: "M2137.118,491.308a31.282,31.282,0,1,1,18.832-6.342,31.3,31.3,0,0,1-18.832,6.342",
    transform: "translate(-1905.614 -388.083)",
    fill: "#dfe9f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5718",
    "data-name": "Grupo 5718",
    transform: "translate(200.616 41.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5717",
    "data-name": "Grupo 5717",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4630",
    "data-name": "Caminho 4630",
    d: "M2444.534,933.366a12.845,12.845,0,0,1,1.977,4.268,102.893,102.893,0,0,1,2.771,11.062c.9,4.6,1.527,9.2,2.015,13.752q.067.617.13,1.234c.2,1.984-.024.224.142,2.178a17.557,17.557,0,0,1,.089,2.606,9.386,9.386,0,0,1-1.619,4.66,4.115,4.115,0,0,1-2.845,2,5.156,5.156,0,0,1-3.62-1.481c-3.833-4.48-3.1-6.926-4.624-12.778-.878-3.36-1.547-7.351-2.354-10.838a25.889,25.889,0,0,1-.061-13.169c.616-2.072,1.838-4.261,3.635-4.966a3.625,3.625,0,0,1,.449-.142,3.966,3.966,0,0,1,3.914,1.614",
    transform: "translate(-2404.699 -884.204)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4631",
    "data-name": "Caminho 4631",
    d: "M2084.556,863.657l-1.126,4.608-.369,1.51-.824,3.366-.11.452-4.654,19.019-2.48,10.084q-.3,1.227-.529,2.47l-.314,1.693,32.25,8.641.011-.027c.7-1.736,1.666-4.892,2.151-6.7l9.881-36.781a5.165,5.165,0,0,0-2.083-5.607c-.065-.046-.136-.087-.208-.128l-.183-.1q-1.848-1.049-3.763-1.958c-.138-.066-.275-.13-.414-.2-.589-.274-1.18-.536-1.776-.79l-.39-.165-.177-.074-.011,0q-.45-.185-.9-.362a57.068,57.068,0,0,0-10.883-3.058q-.43-.077-.86-.146l-.217-.034c-.079-.013-.16-.026-.239-.037-.295-.047-.59-.089-.884-.129l-.106-.014q-2.2-.3-4.437-.427l-.135-.007a2.625,2.625,0,0,0-.346,0,6.457,6.457,0,0,0-5.873,4.909",
    transform: "translate(-2077.524 -818.217)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4632",
    "data-name": "Caminho 4632",
    d: "M2082.24,1009.2l-.111.451-4.653,19.019-2.48,10.084q-.3,1.227-.529,2.47l-.314,1.692,8.638,2.315a5.863,5.863,0,0,0-.062-.6,27.906,27.906,0,0,0-1.331-4.245c-1.674-5.147-.5-12.111.313-17.462q.959-6.272,1.917-12.547a1.332,1.332,0,0,0-.087-.943,1.109,1.109,0,0,0-1.3-.231",
    transform: "translate(-2077.528 -954.277)",
    fill: "#f8bdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4633",
    "data-name": "Caminho 4633",
    d: "M2313.559,868.485c-.767,2.863,1.39,5.928,4.818,6.847s6.83-.657,7.6-3.52a4.507,4.507,0,0,0,.154-1.153l-.177-.074-.011,0c-.3-.123-.6-.244-.9-.362a57.055,57.055,0,0,0-10.883-3.058,4.529,4.529,0,0,0-.6,1.325",
    transform: "translate(-2294.027 -825.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4634",
    "data-name": "Caminho 4634",
    d: "M2344.728,760.549l-.76,2.839c-.618,2.307-2.778,2.887-5.084,2.269l-.083-.022c-2.244-.6-3.823-2.08-3.309-4.345l1.357-5.981a23.714,23.714,0,0,0,.417-2.4l.552-4.555,9.5,2.546Z",
    transform: "translate(-2313.926 -718.319)",
    fill: "#feb0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4635",
    "data-name": "Caminho 4635",
    d: "M2319.851,601.023s-2.238-5.926-.6-11.441c0,0,19.736-3.645,22.065,3.487,0,0-6.39,11.2-21.468,7.955",
    transform: "translate(-2298.777 -573.808)",
    fill: "#9991a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4636",
    "data-name": "Caminho 4636",
    d: "M2313.174,687.525a2.658,2.658,0,0,0-2.47,2.257c-.691,3.023,1.262,4.869,2.8,6.049,2.119,1.632,3.688-.543,3.669-3.161-.015-2.044-1.542-5.267-3.994-5.145",
    transform: "translate(-2291.453 -663.277)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4637",
    "data-name": "Caminho 4637",
    d: "M2380.929,523.524s8.279-10.118,10.541-3.439c0,0,11.335-4.551,8.346,3.209,0,0,6.5,3.059-1.959,8.79,0,0-13.836,6.731-16.928-8.56",
    transform: "translate(-2355.131 -509.699)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4638",
    "data-name": "Caminho 4638",
    d: "M2363.51,624.366a18.921,18.921,0,0,0-1.79,4.988c-.9,3.739-1.795,10.189,2.086,12.6a13.581,13.581,0,0,0,3.831,1.647,8.517,8.517,0,0,0,5.894-.418,7.024,7.024,0,0,0,2.854-2.659,8.968,8.968,0,0,0,.888-1.912c.052-.153.1-.309.146-.465a21.321,21.321,0,0,0,.669-4.263c0-.054.008-.106.012-.16.012-.151.024-.3.034-.452.049-.612.091-1.219.147-1.812a47.975,47.975,0,0,1,.882-4.795c.23-1.162.868-3.008.383-4.142-1.094-2.558-6.083-2.4-8.356-2.257a11.2,11.2,0,0,0-5.013,1.4,7.285,7.285,0,0,0-2.666,2.695",
    transform: "translate(-2337.043 -602.361)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4639",
    "data-name": "Caminho 4639",
    d: "M2322.977,577.878s-7.648-.387-5.8,4.307c0,0,2.717,3.271,7.394-3.173Z",
    transform: "translate(-2297.179 -564.053)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4640",
    "data-name": "Caminho 4640",
    d: "M2360.591,640.909s.03,6.6-2.29,7.048a1,1,0,0,1-1.136-.762l-1.135-4.608Z",
    transform: "translate(-2332.598 -621.097)",
    fill: "#9991a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4641",
    "data-name": "Caminho 4641",
    d: "M2333.135,717.847a.2.2,0,0,1-.084-.018,3.8,3.8,0,0,1-2-2.207.2.2,0,1,1,.386-.131,3.387,3.387,0,0,0,1.785,1.966.2.2,0,0,1-.084.39",
    transform: "translate(-2309.983 -688.461)",
    fill: "#f67a86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4642",
    "data-name": "Caminho 4642",
    d: "M1910.162,894.463a4.216,4.216,0,0,0,3.548.182c6.041-1.849,9.676-7.822,14.321-12.1,1.909-1.759,3.943-3.4,5.924-5.153.786-.693,1.564-1.4,2.322-2.144.052-.049.1-.1.154-.152l.056-.056a35.746,35.746,0,0,0,2.805-3.1,22.242,22.242,0,0,0,4.28-8.132c.611-2.309.634-5.116-1-6.639a4.529,4.529,0,0,0-4.54-.692,13.622,13.622,0,0,0-4.191,2.658c-8.928,7.455-16.108,16.308-22.664,24.912a17.383,17.383,0,0,0-1.515,2.22,9.059,9.059,0,0,0-1.05,4.928,4.2,4.2,0,0,0,1.556,3.269",
    transform: "translate(-1927.703 -815.892)",
    fill: "#95b0ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5720",
    "data-name": "Grupo 5720",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5719",
    "data-name": "Grupo 5719",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4644",
    "data-name": "Caminho 4644",
    d: "M1043.184,147.9H963.875a11.165,11.165,0,0,1-11.165-11.165V14.874A11.165,11.165,0,0,1,963.875,3.709h79.309a11.165,11.165,0,0,1,11.165,11.165V136.732a11.165,11.165,0,0,1-11.165,11.165",
    transform: "translate(-862.112 -3.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4645",
    "data-name": "Caminho 4645",
    d: "M1039.831,144.9H960.522a11.53,11.53,0,0,1-11.517-11.517V11.52A11.53,11.53,0,0,1,960.522,0h79.309a11.53,11.53,0,0,1,11.517,11.517V133.378a11.53,11.53,0,0,1-11.517,11.517M960.522.708A10.825,10.825,0,0,0,949.71,11.52V133.378a10.825,10.825,0,0,0,10.812,10.812h79.309a10.825,10.825,0,0,0,10.812-10.812V11.52A10.825,10.825,0,0,0,1039.831.708Z",
    transform: "translate(-858.759 -0.003)",
    fill: "#dfe7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4646",
    "data-name": "Caminho 4646",
    d: "M1195.637,150.89a34.527,34.527,0,1,1-34.527-34.527,34.527,34.527,0,0,1,34.527,34.527",
    transform: "translate(-1019.451 -105.298)",
    fill: "#dfe9f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5722",
    "data-name": "Grupo 5722",
    transform: "translate(107.132 11.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5721",
    "data-name": "Grupo 5721",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4647",
    "data-name": "Caminho 4647",
    d: "M1371.962,307.455c1.132,3.842-.551,8.041,1.044,12.2,1.233,3.214,4.246,5.958,6.939,8.878,2.78,3.014,5.426,6.681,5.2,10.545-.223,3.77-3.125,6.882-4.157,10.752-.428,1.606-.531,3.33-.978,4.986-2.036,7.549-11.045,12.009-19.6,11.2-8.491-.8-15.712-5.781-20.905-11.527-3.49-3.861-6.272-8.3-6.4-13.131-.2-7.481,5.832-13.921,8.625-20.248a18.974,18.974,0,0,0,1.262-12.529,7.056,7.056,0,0,1-.451-3.664c.466-1.685,2.425-3.032,4.572-3.734a28.776,28.776,0,0,1,6.751-1.047c3.6-.27,7.383-.52,10.728.5a10.784,10.784,0,0,1,7.37,6.819",
    transform: "translate(-1313.461 -282.446)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4648",
    "data-name": "Caminho 4648",
    d: "M1203.179,626.226a12.091,12.091,0,0,1-2.4,3.722,96.8,96.8,0,0,1-7.4,7.776c-3.2,3.031-6.55,5.851-9.92,8.529q-.457.364-.916.725-2.212,1.742-4.422,3.413a16.542,16.542,0,0,1-2.028,1.383,8.837,8.837,0,0,1-4.521,1.06,3.873,3.873,0,0,1-3.025-1.254,3.471,3.471,0,0,1-.208-3.079c1.632-5.305,7.085-8.645,10.969-12.808,2.23-2.391,4.253-4.987,6.62-7.385a24.367,24.367,0,0,1,10.441-6.682c1.958-.554,4.314-.685,5.78.388a3.379,3.379,0,0,1,.339.286,3.733,3.733,0,0,1,.688,3.926",
    transform: "translate(-1164.139 -573.198)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4649",
    "data-name": "Caminho 4649",
    d: "M1327.63,724.6l-.051.269c-3.2,3.031-6.55,5.851-9.92,8.529a6.6,6.6,0,0,1-1.212-2.649c-.385-2.317,1.156-4.469,2.611-6.313l4.094-5.189c.685-.868,1.56-1.825,2.661-1.731,1.147.1,1.872,1.311,2.088,2.442a12.553,12.553,0,0,1-.271,4.642",
    transform: "translate(-1298.337 -660.344)",
    fill: "#7598ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4650",
    "data-name": "Caminho 4650",
    d: "M1168.069,628.61q.082-1.185.209-2.356c.385-3.568,1.062-7.022,1.716-10.362,1.239-6.327.524-4.98,1.624-10.6a3.368,3.368,0,0,0-.092-2.328,3.422,3.422,0,0,0-2.106-1.232l-.048-.014a5.008,5.008,0,0,0-6.105,3.286q-.069.229-.133.451c-2.567,8.814-3.516,11.247-4.876,21.984a13.671,13.671,0,0,0-.154,2.575,5.07,5.07,0,0,0,2.538,4.281,4.822,4.822,0,0,0,5.058-.675,6.88,6.88,0,0,0,2.37-5.012",
    transform: "translate(-1155.092 -555.392)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4651",
    "data-name": "Caminho 4651",
    d: "M1397.956,634.887a44.342,44.342,0,0,1-1.414,6.361s-2.894,11.256-2.894,21.441h-25.365l.1-12.26s-8.988-6.314-3-16.8l4.8-8.825a6.832,6.832,0,0,1,3.664-3.156,6.593,6.593,0,0,1,.749-.226,6.841,6.841,0,0,1,1.594-.188H1392.2s.037,0,.1.016c.9.16,7.312,1.728,5.655,13.637",
    transform: "translate(-1340.811 -573.223)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4652",
    "data-name": "Caminho 4652",
    d: "M1609.7,775.507l-1.185,3.208s-2.894,11.256-2.894,21.442h-7.18c.317-.756.811-1.425,1.179-2.157a7.307,7.307,0,0,0-.645-7.464c-.716-.966-1.74-2.062-1.291-3.176a3.06,3.06,0,0,1,1.247-1.239q.148-.1.294-.206a18.228,18.228,0,0,0,7.387-12.289l.068-.478a32.823,32.823,0,0,0,3.021,2.36",
    transform: "translate(-1552.781 -710.69)",
    fill: "#f8bdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4653",
    "data-name": "Caminho 4653",
    d: "M1658.388,652.838a2.922,2.922,0,0,1-4.518,2.453c-4.868-2.024-7.4-7.279-10.916-11.208-1.444-1.615-3-3.146-4.5-4.76-.6-.639-1.185-1.292-1.755-1.968-.039-.045-.077-.092-.115-.138a21.191,21.191,0,0,1-5.019-9.953c-.321-1.967-.112-4.3,1.372-5.433a3.779,3.779,0,0,1,3.826-.208,11.378,11.378,0,0,1,3.266,2.547c6.813,6.913,12.061,14.848,16.81,22.524a14.47,14.47,0,0,1,1.079,1.967,7.555,7.555,0,0,1,.474,4.178",
    transform: "translate(-1583.423 -573.198)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4654",
    "data-name": "Caminho 4654",
    d: "M1484.965,621.246c-5.859,13.246-13.725,11.932-13.725,11.932-6.737,0-4.492-9.816-4.049-11.531a6.606,6.606,0,0,1,.749-.226,6.845,6.845,0,0,1,1.594-.188h15.328s.037,0,.1.013",
    transform: "translate(-1434.155 -573.222)",
    fill: "#feb0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4655",
    "data-name": "Caminho 4655",
    d: "M1405.98,280.361a10.073,10.073,0,0,0,3.781,7.716c2.544,2.121,6.719,3.359,9.452,1.609,3.895-2.494,3.982-7.173,3.018-11.165-.572-2.371-2.351-9.771-6.567-9.84a5.127,5.127,0,0,0-1.833.369,12.139,12.139,0,0,0-7.851,11.31",
    transform: "translate(-1379.41 -254.196)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4656",
    "data-name": "Caminho 4656",
    d: "M1463.152,281.232a14.593,14.593,0,0,1-9.009,12.017,20.569,20.569,0,0,1-4.317,1.24c-3.1.564-6.327.568-8.765-.491a9.253,9.253,0,0,1-4.569-4.671,22.112,22.112,0,0,1-1.587-12.892,17.821,17.821,0,0,1,2.353-7.106,7.492,7.492,0,0,1,3.638-3.224,10.025,10.025,0,0,1,5.122-.144,43.562,43.562,0,0,1,6.319,1.349c6.919,2.2,11.209,7.723,10.816,13.923",
    transform: "translate(-1405.316 -251.497)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4657",
    "data-name": "Caminho 4657",
    d: "M1524.551,500.35c0,.954.006,3.228.01,4.183a10.588,10.588,0,0,0,.53,4,3.6,3.6,0,0,0,3.009,2.384,4.271,4.271,0,0,0,4.047-2.981,8.91,8.91,0,0,0,.181-2.659,51.31,51.31,0,0,1,.458-7.733,3.672,3.672,0,0,0,.057-1.4c-.264-1.156-1.616-1.728-2.8-1.726a5.57,5.57,0,0,0-4.123,1.872,5.775,5.775,0,0,0-1.365,4.064",
    transform: "translate(-1486.706 -458.463)",
    fill: "#feb0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4658",
    "data-name": "Caminho 4658",
    d: "M1599.723,446.614a2.725,2.725,0,0,1,1.412,3.126c-.574,3.127-3.161,4.073-5.084,4.564-2.657.678-3.254-2.005-2.175-4.463.843-1.919,3.586-4.336,5.846-3.227",
    transform: "translate(-1548.979 -414.956)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4659",
    "data-name": "Caminho 4659",
    d: "M1446.928,298.267a20.378,20.378,0,0,1-.743,8.768,12.6,12.6,0,0,1-5.314,6.867,10.64,10.64,0,0,1-9.519.575,5.992,5.992,0,0,1-2.219-1.547,6.619,6.619,0,0,1-1.079-5.469,17.054,17.054,0,0,1,.4-1.828c.3-1.115.557-2.239.791-3.369.433-2.07.794-4.156,1.23-6.225.458-2.179,1-4.5,2.629-6.019,2.221-2.063,5.843-1.891,8.5-.424a10.1,10.1,0,0,1,4.518,5.043,14.069,14.069,0,0,1,.813,3.629",
    transform: "translate(-1399.256 -272.115)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4660",
    "data-name": "Caminho 4660",
    d: "M1624.682,477a.164.164,0,0,1-.019-.327,2.782,2.782,0,0,0,1.887-1.094.164.164,0,0,1,.264.195A3.116,3.116,0,0,1,1624.7,477h-.019",
    transform: "translate(-1577.167 -441.361)",
    fill: "#f67a86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4661",
    "data-name": "Caminho 4661",
    d: "M1479.666,281.781c.714-1.495.36-3.5-.089-4.947a8.453,8.453,0,0,0-2.947-4.25,1.729,1.729,0,0,0-2.917.849,7.949,7.949,0,0,0,.514,5.47,9.084,9.084,0,0,0,2.254,3.374,2,2,0,0,0,3.162-.452l.022-.045",
    transform: "translate(-1440.446 -257.284)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4662",
    "data-name": "Caminho 4662",
    d: "M1440.3,280.493c.8-.1,1.817-1.234,2.54-2.2a13.872,13.872,0,0,0,2.047-4.1c.389-1.248.192-2.148-.574-1.873a6.818,6.818,0,0,0-2.789,2.756,14.872,14.872,0,0,0-1.629,3.187c-.37,1.074-.312,2.3.382,2.233l.024,0",
    transform: "translate(-1409.897 -257.444)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4663",
    "data-name": "Caminho 4663",
    d: "M1508.638,288.453a2.148,2.148,0,0,0,.685-.841,2.873,2.873,0,0,0,.165-1.843,11.79,11.79,0,0,0-1.505-3.44,16.312,16.312,0,0,0-9.481-6.8,4.43,4.43,0,0,0-2.709-.186c-1.423.55-.9,2.1-.35,3.066a24.846,24.846,0,0,0,7.177,8.433c1.2.822,4.337,2.8,6.018,1.605",
    transform: "translate(-1459.855 -260.092)",
    fill: "#5d5576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4664",
    "data-name": "Caminho 4664",
    d: "M1629.037,515.019a1.31,1.31,0,1,1-1.475-1.121,1.31,1.31,0,0,1,1.475,1.121",
    transform: "translate(-1578.896 -476.084)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4665",
    "data-name": "Caminho 4665",
    d: "M1226.039,527.044a8.259,8.259,0,0,0-4.271-2.631,3.015,3.015,0,0,0-1.636-.193c-.912.228-1.419,1.176-1.816,2.028l-.447.959-.309-.244a1.3,1.3,0,0,0-1.052-.4.969.969,0,0,0-.611.672,2.755,2.755,0,0,0-.107,1.024,5.231,5.231,0,0,0,.593,2.144,2.337,2.337,0,0,0,.155.256,3.365,3.365,0,0,0,.3.653,7.941,7.941,0,0,1,.782,2.414.469.469,0,0,0,.316.393,13.751,13.751,0,0,0,5.017.363.47.47,0,0,0,.451-.482,4.408,4.408,0,0,1,.715-2.407,21.348,21.348,0,0,1,1.854-2.356,2.028,2.028,0,0,0,.493-.881,1.767,1.767,0,0,0-.427-1.311",
    transform: "translate(-1207.3 -485.389)",
    fill: "#feb0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4666",
    "data-name": "Caminho 4666",
    d: "M1215.763,547.056a4.061,4.061,0,0,1,1.268.874,9.539,9.539,0,0,1,1.653,1.756,1.246,1.246,0,0,1,.2.415.508.508,0,0,1-.09.437.593.593,0,0,1-.308.169,2.42,2.42,0,0,1-1.251-.12,5.221,5.221,0,0,1-1.958-.895,1.982,1.982,0,0,1-.753-1.914,1,1,0,0,1,.839-.8,1.064,1.064,0,0,1,.4.075",
    transform: "translate(-1206.119 -506.031)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4667",
    "data-name": "Caminho 4667",
    d: "M1223.83,526.674a3.1,3.1,0,0,1-.176-.256,1.8,1.8,0,0,1-.242-1.125,1.32,1.32,0,0,1,.27-.685.869.869,0,0,1,.644-.33,1.239,1.239,0,0,1,.619.2,7.972,7.972,0,0,1,2.64,3.17,1.328,1.328,0,0,1,.242.72.767.767,0,0,1-.666.667,1.528,1.528,0,0,1-.869-.221,6.663,6.663,0,0,1-2.04-1.61c-.085-.1-.168-.2-.248-.306q-.087-.112-.172-.226",
    transform: "translate(-1214.193 -485.486)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4668",
    "data-name": "Caminho 4668",
    d: "M1243.089,487.276a.632.632,0,0,0-.388.2,2.055,2.055,0,0,0-.482,1.54,9.984,9.984,0,0,0,.409,2.33,3.56,3.56,0,0,0,.568,1.345,1.254,1.254,0,0,0,1.293.491,1.217,1.217,0,0,0,.759-.957,2.9,2.9,0,0,0-.114-1.267,15.535,15.535,0,0,0-.786-2.173,4.028,4.028,0,0,0-.741-1.246.71.71,0,0,0-.518-.261",
    transform: "translate(-1231.221 -452.003)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4669",
    "data-name": "Caminho 4669",
    d: "M1278.545,483.169a8.635,8.635,0,0,1,.271,1.32c.027.221.044.443.058.665q.03.488.034.977a3.631,3.631,0,0,1-.1,1.033,1.4,1.4,0,0,1-.589.829,1.07,1.07,0,0,1-.831.109,1.406,1.406,0,0,1-.895-.982,3.549,3.549,0,0,1-.057-1.376,16.273,16.273,0,0,1,.436-2.41,2.012,2.012,0,0,1,.3-.721.743.743,0,0,1,.675-.32.731.731,0,0,1,.473.33,1.885,1.885,0,0,1,.226.546",
    transform: "translate(-1262.15 -447.489)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4670",
    "data-name": "Caminho 4670",
    d: "M1293.948,536.759a2.3,2.3,0,0,0-.227-.713,1.483,1.483,0,0,0-1.487-.664,2.19,2.19,0,0,0-1.41.921,4.3,4.3,0,0,0-.653,1.589,3.76,3.76,0,0,0-.1.677,4.854,4.854,0,0,0,.289,1.568,2.318,2.318,0,0,0,.57,1.106.536.536,0,0,0,.512.154.736.736,0,0,0,.325-.327,24.222,24.222,0,0,1,1.564-1.875,2.935,2.935,0,0,0,.68-1.274,3.132,3.132,0,0,0-.063-1.165",
    transform: "translate(-1274.522 -495.522)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4671",
    "data-name": "Caminho 4671",
    d: "M1265.342,517.2a1.585,1.585,0,0,0,.947.881,2.629,2.629,0,0,0,.933.018,10.814,10.814,0,0,1,1.619-.017,7.277,7.277,0,0,0,1.744.02,2.719,2.719,0,0,0,.75-.25,7.182,7.182,0,0,0-1-2.378,1.352,1.352,0,0,0-.233-.254,1.115,1.115,0,0,0-.311-.169,2.233,2.233,0,0,0-1.2-.058,6.656,6.656,0,0,0-1.156.38l-1.729.688a.99.99,0,0,0-.308.168.624.624,0,0,0-.185.471,1.219,1.219,0,0,0,.135.5",
    transform: "translate(-1252.025 -477.036)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4672",
    "data-name": "Caminho 4672",
    d: "M1280.573,437.828a1.016,1.016,0,0,0,.667-.642,3.007,3.007,0,0,0,.168-.975c.033-.623.039-1.247.045-1.87q.009-.861.017-1.722a5.781,5.781,0,0,0-.168-1.841,1.367,1.367,0,0,0-.315-.592.568.568,0,0,0-.594-.156c-.307.123-.406.528-.463.874a29.123,29.123,0,0,0-.554,5.1,2.849,2.849,0,0,0,.221,1.25.95.95,0,0,0,.976.577",
    transform: "translate(-1264.845 -400.172)",
    fill: "#fec1bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4673",
    "data-name": "Caminho 4673",
    d: "M1232.57,447.154a1.016,1.016,0,0,0,.443-.813,3.009,3.009,0,0,0-.132-.981c-.155-.6-.336-1.2-.517-1.8l-.5-1.648a5.777,5.777,0,0,0-.712-1.706,1.367,1.367,0,0,0-.478-.471.568.568,0,0,0-.613.029c-.256.209-.229.626-.179.973a29.1,29.1,0,0,0,1,5.029,2.845,2.845,0,0,0,.585,1.126.95.95,0,0,0,1.1.258",
    transform: "translate(-1220.029 -408.919)",
    fill: "#fec1bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5724",
    "data-name": "Grupo 5724",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5723",
    "data-name": "Grupo 5723",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4675",
    "data-name": "Caminho 4675",
    d: "M1752.146,978.581a12.728,12.728,0,0,0,1.72,2.265.713.713,0,0,1,.188.591,14.265,14.265,0,0,0-.139,2.693.709.709,0,0,0,.874.657,13.581,13.581,0,0,0,2.646-.933.711.711,0,0,1,.613,0,15.8,15.8,0,0,0,1.8.738c.276.094.524.17.737.229a.711.711,0,0,0,.9-.632l.008-.114a13.136,13.136,0,0,0-.093-2.64.711.711,0,0,1,.195-.589,14.772,14.772,0,0,0,1.731-2.15.71.71,0,0,0-.314-1.042,13.653,13.653,0,0,0-2.768-.849.706.706,0,0,1-.491-.363,16.082,16.082,0,0,0-1.409-2.195.709.709,0,0,0-1.11-.019,14.494,14.494,0,0,0-1.5,2.194.71.71,0,0,1-.5.356,13.837,13.837,0,0,0-2.746.778.71.71,0,0,0-.345,1.021",
    transform: "translate(-1585.436 -881.354)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4676",
    "data-name": "Caminho 4676",
    d: "M1591,978.581a12.722,12.722,0,0,0,1.72,2.265.713.713,0,0,1,.188.591,14.274,14.274,0,0,0-.139,2.693.709.709,0,0,0,.874.657,13.581,13.581,0,0,0,2.646-.933.71.71,0,0,1,.613,0,15.8,15.8,0,0,0,1.8.738c.276.094.524.17.737.229a.711.711,0,0,0,.9-.632l.008-.114a13.136,13.136,0,0,0-.093-2.64.711.711,0,0,1,.195-.589,14.763,14.763,0,0,0,1.731-2.15.71.71,0,0,0-.314-1.042,13.654,13.654,0,0,0-2.768-.849.706.706,0,0,1-.491-.363,16.07,16.07,0,0,0-1.409-2.195.709.709,0,0,0-1.11-.019,14.5,14.5,0,0,0-1.5,2.194.71.71,0,0,1-.5.356,13.838,13.838,0,0,0-2.746.778.71.71,0,0,0-.345,1.021",
    transform: "translate(-1439.609 -881.354)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4677",
    "data-name": "Caminho 4677",
    d: "M1429.845,978.581a12.728,12.728,0,0,0,1.72,2.265.712.712,0,0,1,.188.591,14.274,14.274,0,0,0-.139,2.693.709.709,0,0,0,.874.657,13.584,13.584,0,0,0,2.646-.933.71.71,0,0,1,.613,0,15.8,15.8,0,0,0,1.8.738c.276.094.524.17.737.229a.711.711,0,0,0,.9-.632l.008-.114a13.136,13.136,0,0,0-.093-2.64.71.71,0,0,1,.195-.589,14.761,14.761,0,0,0,1.73-2.15.71.71,0,0,0-.314-1.042,13.653,13.653,0,0,0-2.768-.849.706.706,0,0,1-.491-.363,16.094,16.094,0,0,0-1.409-2.195.709.709,0,0,0-1.11-.019,14.5,14.5,0,0,0-1.5,2.194.71.71,0,0,1-.5.356,13.84,13.84,0,0,0-2.746.778.71.71,0,0,0-.345,1.021",
    transform: "translate(-1293.783 -881.354)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4678",
    "data-name": "Caminho 4678",
    d: "M1268.694,978.581a12.733,12.733,0,0,0,1.72,2.265.712.712,0,0,1,.188.591,14.274,14.274,0,0,0-.139,2.693.709.709,0,0,0,.874.657,13.582,13.582,0,0,0,2.646-.933.71.71,0,0,1,.613,0,15.8,15.8,0,0,0,1.8.738c.276.094.524.17.737.229a.711.711,0,0,0,.9-.632c0-.038.005-.076.008-.114a13.136,13.136,0,0,0-.093-2.64.711.711,0,0,1,.195-.589,14.763,14.763,0,0,0,1.731-2.15.71.71,0,0,0-.314-1.042,13.653,13.653,0,0,0-2.768-.849.706.706,0,0,1-.491-.363,16.069,16.069,0,0,0-1.409-2.195.709.709,0,0,0-1.11-.019,14.485,14.485,0,0,0-1.5,2.194.71.71,0,0,1-.5.356,13.837,13.837,0,0,0-2.746.778.71.71,0,0,0-.345,1.021",
    transform: "translate(-1147.957 -881.354)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4679",
    "data-name": "Caminho 4679",
    d: "M1107.542,978.581a12.716,12.716,0,0,0,1.72,2.265.712.712,0,0,1,.188.591,14.294,14.294,0,0,0-.139,2.693.709.709,0,0,0,.874.657,13.578,13.578,0,0,0,2.646-.933.71.71,0,0,1,.613,0,15.819,15.819,0,0,0,1.8.738c.276.094.524.17.737.229a.711.711,0,0,0,.9-.632c0-.038.005-.076.008-.114a13.136,13.136,0,0,0-.093-2.64.711.711,0,0,1,.195-.589,14.755,14.755,0,0,0,1.731-2.15.71.71,0,0,0-.314-1.042,13.653,13.653,0,0,0-2.768-.849.706.706,0,0,1-.491-.363,16.059,16.059,0,0,0-1.409-2.195.709.709,0,0,0-1.11-.019,14.493,14.493,0,0,0-1.5,2.194.71.71,0,0,1-.5.356,13.84,13.84,0,0,0-2.746.778.71.71,0,0,0-.344,1.021",
    transform: "translate(-1002.13 -881.354)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4680",
    "data-name": "Caminho 4680",
    d: "M1233.352,1217.771h-58.585a.721.721,0,0,1-.721-.721v-.015a.721.721,0,0,1,.721-.721h58.585a.721.721,0,0,1,.721.721v.015a.721.721,0,0,1-.721.721",
    transform: "translate(-1062.4 -1100.65)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4681",
    "data-name": "Caminho 4681",
    d: "M1233.352,1279.022h-58.585a.721.721,0,0,1-.721-.721v-.015a.721.721,0,0,1,.721-.721h58.585a.721.721,0,0,1,.721.721v.015a.721.721,0,0,1-.721.721",
    transform: "translate(-1062.4 -1156.076)",
    fill: "#95b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4682",
    "data-name": "Caminho 4682",
    d: "M1353.223,1340.274h-30.432a.721.721,0,0,1-.721-.721v-.014a.721.721,0,0,1,.721-.721h30.432a.721.721,0,0,1,.721.721v.014a.721.721,0,0,1-.721.721",
    transform: "translate(-1196.348 -1211.503)",
    fill: "#95b0ff"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRatingNps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rating-nps.42509e5f.svg";
export { ForwardRef as ReactComponent };